module.exports = __webpack_public_path__ + "img/halalbg.07f157fd.png";